import classNames from "classnames";
import { InaccessibleTabMessage } from "../InaccessibleTabMessage";
import { useSubscriptionDetailsSuite } from "@/Hooks/useSubscriptionDetailsSuite";
import { checkEligibleEcommItems, handleChildTabClick } from "../../Utils";
import { ChildTabProps } from "../../Types";

export function ChildTab(props: ChildTabProps) {
  const {
    subNavListItem,
    isParentTabActive,
    activeSubTabId,
    activeHoveredSubTabId,
    onHoverSubTab,
    isDropdown,
    anchorEl,
    setAnchorEl,
  } = props;

  const {
    id: childId,
    name,
    route: childTabRoute,
    accessable,
    visible,
    requiredPermission,
    openInNewTab = false,
    Icon = null,
  } = subNavListItem;
  const isSubNavListItemActive = isParentTabActive && childId === activeSubTabId;
  const isSubNavListItemHovered = !isSubNavListItemActive && activeHoveredSubTabId === childId;

  const { isEcommPro, checkSubscriptionExpiry } = useSubscriptionDetailsSuite();

  function handleSubTabClick(e: Event) {
    e.stopPropagation();
    if (!accessable) {
      return;
    }
    handleChildTabClick(childTabRoute, openInNewTab);
  }

  function getTabClasses() {
    switch (true) {
      case isParentTabActive && isSubNavListItemActive:
        return `tw-font-bold tw-text-[#2B74D8] ${isDropdown ? "tw-bg-[#EAF2FD]" : ""}`;
      case isSubNavListItemHovered:
        return "tw-font-normal tw-bg-[#111C360D]";
      default:
        return `tw-font-normal ${isDropdown ? "tw-text-[#111C36B2]" : "tw-text-[#111C36]"}`;
    }
  }

  function renderTab() {
    return (
      <div
        className={classNames(
          "tw-flex tw-flex-1 tw-flex-nowrap tw-items-center tw-justify-between tw-text-nowrap",
          getTabClasses(),
          isDropdown ? "tw-rounded-md tw-px-[12px] tw-py-[8px]" : "tw-px-[18px] tw-py-[6px]",
        )}
        onClick={checkSubscriptionExpiry(handleSubTabClick, checkEligibleEcommItems(subNavListItem, isEcommPro))}
        onMouseEnter={(e) => {
          setAnchorEl(e.currentTarget);
          onHoverSubTab(childId);
        }}
      >
        {name} {Icon && (typeof Icon === "function" ? <Icon /> : Icon)}
      </div>
    );
  }

  return (
    visible && 
      <div
        className={classNames(
          "tw-relative tw-flex tw-cursor-pointer tw-items-center",
          isDropdown ? "tw-pl-[23px] tw-pr-[12px]" : "",
        )}
        onMouseLeave={(e) => {
          onHoverSubTab(null);
        }}
      >
        {renderTab()}
        {!accessable && isSubNavListItemHovered && 
          <InaccessibleTabMessage
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            requiredPermission={requiredPermission}
          />
        }
      </div>
    
  );
}
